import { Edit, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import BackButtonToolbar from "features/BackButtonToolbar";

const EditExams = () => {
  return (
    <Edit
      title="Редакция на изпит"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};
export default EditExams;
